<template>
    <div class="memwrap modulewrap">
        <Cmember :curnavkv="curnavkv" :options="options" @optionsupdate="memopup" :navsub.sync="navsub">
            <Cschedule :navsub="navsub" :options="c_myoption" v-if="isload"></Cschedule>
        </Cmember>

    </div>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'schedule',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 4,
                navsub: 1,
                options: {
                    hasoption: 1,
                    haslevel: 1,
                    hasproject: 1,
                    haskw: 1
                }
            };
        },
        components: {
            Cschedule: () => import('@/components/Cschedule')
        },
        computed: {
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.k = this.navsub;
                return _myoption;
            }
        }
    }
</script>
